import React from 'react';
import OrderInfo from './OrderInfo';
import AssaysList from './AssaysList';
import makeStyles from '@material-ui/core/styles/makeStyles';
import renderInExceptionRoot from '../../utils/renderInExceptionRoot';
import LoadOrderResultDialog from '../LoadOrderResultDialog';
import {IOrder} from '../../common/types';


const useStyles = makeStyles({
  root: {
    width: '100%',
    minWidth: 320,
    display: 'grid',
    gridTemplateRows: '80px 1fr',
    boxShadow: '0 0 1px 1px rgba(0, 0, 0, 0.1)',
    transition: 'background 600ms ease',
    userSelect: 'none',
    '&:hover': {
      background: '#f0f0f0'
    },
    '&:active': {
      background: '#ebebeb'
    }
  }
});

const OrderCard = ({id, date, address, assays}: IOrder) => {
  const cl = useStyles();
  const onClick = (open: boolean) => renderInExceptionRoot(({unmountComponent}) =>
    <LoadOrderResultDialog unmountComponent={unmountComponent} id={id} date={date} open={open}/>
  );
  return (
    <div className={cl.root} /*onClick={onClick}*/>
      <OrderInfo date={date} address={address} clickHandle={onClick}/>
      <AssaysList assays={assays}/>
    </div>
  );
};

export default OrderCard;

